import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import ServiceReportsTable from './partials/ServiceReportsTable'

import { getServiceReports } from './services'
import { handleError, parsePagination } from '../../helpers'

export default function ServiceReportsList() {
	const [serviceReports, setServiceReports] = useState(null)
	const [filterType, setFilterType] = useState('sku')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})

	useEffect(() => {
		!serviceReports && getServiceReports({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'service.location.company,reportFormat,serviceResult'
		})
			.then(res => {
				setServiceReports(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ serviceReports, pagination, filterType, filterValue ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Reportes de Servicios"
				subtitle="Listado de reportes de servicio registrados en la plataforma"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setServiceReports(null)}
				options={[
					{ label: 'Buscar por consecutivo', value: 'sku' },
					{ label: 'Buscar por razón social', value: 'service.location.company.legal_name' },
					{ label: 'Buscar por NIT de cliente', value: 'service.location.company.document' },
					{ label: 'Buscar nombre del servicio', value: 'service.serviceFormat.name' },
					{ label: 'Buscar fecha del servicio (YYYY-MM-DD)', value: 'service.service_at' },
					{ label: 'Buscar por nombre del técnico asignado', value: 'service.serviceTechnicians.technician.name' },
					{ label: 'Buscar por cedula del técnico asignado', value: 'service.serviceTechnicians.technician.document' },
					{ label: 'Buscar por placas de vehículo asociado', value: 'service.serviceVehicles.vehicle.placas' },
					{ label: 'Buscar por asesor asignado', value: 'service.user.name' },
				]}
			/>
			<Card>
				<CardBody>
					<ServiceReportsTable 
						serviceReports={serviceReports}
						reload={() => setServiceReports(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}